const auth = {
  email: 'Email',
  emailplaceholderlogin: 'donkey@kong.io',
  forgetsuccessfullmessage: 'We have sent an Email with instructions to the Email Address',
  haveaccount: 'Allready have an Account?',
  loginhere: 'Login here!',
  notregisterd: 'Not registered yet?',
  password: 'Password',
  passwordplaceholderlogin: 'Enter Password',
  passwordconfirm: 'Confirm Password:',
  placeholderpassword: 'Confirm Password',
  register: 'Register',
  registrationemail: 'We have send you an Email with a verification code you need to confirm your email before you can login.',
  registrationsuccessfull: 'Your registration was successful',
  resetpassword: 'Reset Password',
  resetpasswordlink: 'Click here to reset password.',
  signup: 'Sign up!',
  authheading: 'Login',
  authintro: '👋 Hey, nice to have you here.',
  verifyheading: 'Verifying your account...',
  verifymessage: 'Hold on a second...',
  tos: 'I accept the <a href="https://backupmonkey.io/en/tos" target="_blank">terms of service</a> and <a href="https://backupmonkey.io/en/data-policy" target="_blank">privacy policy</a>.',
  coupon: 'Coupon',
  placeholdercoupon: 'Coupon code, if you have one'
}

export default auth
